"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bi = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
/** @internal */
exports.bi = (0, host_modules_1.createHostModule)({
    getLogger: (host) => () => {
        if (!host.getBiLogger) {
            throw new Error('Host bi logger is not available on the current host. Make sure to use an updated version of the host initialization pacakge.');
        }
        return host.getBiLogger();
    },
});
